const TECHNOLOGY_TYPE = [
  { displayName: "5G", dbName: "cbrs_5g" },
  { displayName: "Wi-Fi 6E", dbName: "wifi_6e" },
  { displayName: "Tarana", dbName: "tarana" },
];

export default TECHNOLOGY_TYPE;
